export default __webpack_public_path__ + "static/clouds-a1a994c756da9d1a48afc11b7337a62c.mp4";